module.exports = __webpack_public_path__ + "bab011eaa4cf23e4084cdfcc4df67955.png";